import type { QueryClient } from '@lib/query/client';

/** Refreshes deal-limit banner state after active deal count changes. */
export function invalidateDealEntitlementQueries(
  queryClient: QueryClient
): void {
  void queryClient.invalidateQueries({
    queryKey: ['billing', 'deal-entitlement'],
  });
}
